import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import '../components/LandigPage.css';

// Componentes de iconos (puedes reemplazarlos con una librería de iconos o SVGs)
const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </svg>
);

const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12,6 12,12 16,14"/>
  </svg>
);

const CheckSquareIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="9,11 12,14 22,4"/>
    <path d="m21,12v7a2,2 0 0,1 -2,2H5a2,2 0 0,1 -2,-2V5a2,2 0 0,1 2,-2h11"/>
  </svg>
);

const ArrowRightIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12,5 19,12 12,19"/>
  </svg>
);

const StarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26 12,2"/>
  </svg>
);

const BarChart3Icon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 3v18h18"/>
    <path d="m19 9-5 5-4-4-3 3"/>
  </svg>
);

const TargetIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </svg>
);

const ZapIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2"/>
  </svg>
);

const LandingPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentFeature, setCurrentFeature] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentFeature((prev) => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const features = [
    {
      icon: <ClockIcon />,
      title: "Técnica Pomodoro",
      description: "Sesiones de trabajo de 50 minutos con descansos perfectamente cronometrados",
      iconClass: "pomodoro"
    },
    {
      icon: <CheckSquareIcon />,
      title: "Gestión de Tareas",
      description: "Organiza y prioriza todas tus tareas de manera intuitiva y eficiente",
      iconClass: "tasks"
    },
    {
      icon: <CalendarIcon />,
      title: "Planificación de Eventos",
      description: "Programa eventos y mantén tu calendario siempre bajo control",
      iconClass: "calendar"
    }
  ];

  return (
    <div className="landing-container">
      {/* Elementos decorativos de fondo */}
      <div className="bg-decoration">
        <div className="bg-blob bg-blob-1"></div>
        <div className="bg-blob bg-blob-2"></div>
        <div className="bg-blob bg-blob-3"></div>
      </div>

      {/* Header */}
      <header className="landing-header">
        <nav className="landing-nav">
          <div className="landing-logo">
            <div className="landing-logo-icon">
              <CalendarIcon />
            </div>
            <span className="landing-logo-text">PomTask</span>
          </div>
          <div className="landing-nav-links">
            <a href="#features">Características</a>
            <a href="#pricing">Precios</a>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main className="landing-main-content">
        <div className={`landing-hero-section ${isVisible ? 'visible' : 'hidden'}`}>
          <div>
            <span className="landing-hero-badge">
              <StarIcon />
              La app de productividad más popular
            </span>
          </div>
          
          <h1 className="landing-hero-title">
            <span className="landing-hero-title-line1">Maximiza tu</span>
            <br />
            <span className="landing-hero-title-line2">Productividad</span>
          </h1>
          
          <p className="landing-hero-description">
            Combina la técnica Pomodoro con gestión inteligente de tareas y eventos. 
            <span className="landing-hero-description-highlight"> Transforma tu forma de trabajar</span> y alcanza tus objetivos más rápido.
          </p>

          {/* CTA Buttons */}
          <div className="landing-cta-buttons">
            <button
              className="landing-btn-primary"
              onClick={() => handleNavigation("/signup")}
            >
              <span className="btn-content">
                Comenzar Gratis
                <ArrowRightIcon />
              </span>
            </button>
            
            <button
              className="landing-btn-secondary"
              onClick={() => handleNavigation("/login")}
            >
              Iniciar Sesión
            </button>
          </div>
        </div>

        {/* Features Showcase */}
        <div id="features" className="landing-features-section">
          <h2 className="landing-features-title">
            Todo lo que necesitas en una app
          </h2>
          
          <div className="landing-features-grid">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`landing-feature-card ${currentFeature === index ? 'active' : ''}`}
              >
                <div className="landing-feature-card-bg"></div>
                
                <div className="landing-feature-card-content">
                  <div className={`landing-feature-icon ${feature.iconClass}`}>
                    {feature.icon}
                  </div>
                  
                  <h3 className="landing-feature-title">{feature.title}</h3>
                  <p className="landing-feature-description">{feature.description}</p>
                </div>

                {/* Indicador activo */}
                {currentFeature === index && (
                  <div className="landing-feature-indicator"></div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Additional Features */}
        <div className="landing-additional-section">
          <div className="landing-additional-content">
            <h3>Análisis y Progreso</h3>
            <p>
              Visualiza tu productividad con gráficos detallados y métricas personalizadas. 
              Identifica patrones y optimiza tu flujo de trabajo.
            </p>
            <div className="landing-features-list">
              <div className="landing-feature-item metrics">
                <BarChart3Icon />
                <span>Métricas en tiempo real</span>
              </div>
              <div className="landing-feature-item goals">
                <TargetIcon />
                <span>Objetivos personalizables</span>
              </div>
            </div>
          </div>
          
          <div className="landing-dashboard-mockup">
            <div className="landing-dashboard-card">
              <div className="landing-dashboard-content">
                <BarChart3Icon />
                <p>Dashboard Interactivo</p>
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Section */}
        <div
  className="landing-pricing-section"
  style={{
    display: "flex",
    gap: "2rem",
    flexWrap: "wrap",
    justifyContent: "center",
    margin: "6rem 0 4rem 0",
    background: "none",
    borderRadius: "2rem",
    boxShadow: "none",
    padding: "3rem 1rem"
  }}
>
  {/* Plan Gratuito */}
  <div
    className="landing-pricing-card"
    style={{
      background: "linear-gradient(135deg, #e0e7ef 60%, #f1f5f9 100%)",
      borderRadius: "1.5rem",
      boxShadow: "0 4px 24px rgba(59,130,246,0.10)",
      padding: "2.5rem 2rem",
      minWidth: 260,
      maxWidth: 320,
      textAlign: "center",
      color: "#222",
      border: "2px solid #c7d2fe",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between"
    }}
  >
    <div>
      <h2 style={{ color: "#2563eb", fontSize: 24, marginBottom: 8 }}>Gratis</h2>
      <div style={{ fontSize: 32, fontWeight: "bold", marginBottom: 12 }}>0€</div>
      <ul style={{ listStyle: "none", padding: 0, marginBottom: 20, color: "#444", textAlign: "left" }}>
        <li>✔️ Tareas ilimitadas</li>
        <li>✔️ Pomodoros ilimitados</li>
        <li>✔️ Estadísticas básicas</li>
        <li>✔️ Sin anuncios</li>
      </ul>
    </div>
    <button
      className="landing-btn-primary"
      style={{ width: "100%", marginTop: "auto" }}
      onClick={() => handleNavigation("/signup")}
    >
      Empezar gratis
    </button>
  </div>
  {/* Plan Donación */}
  <div id="pricing"
    className="landing-pricing-card"
    style={{
      background: "linear-gradient(135deg, #fef9c3 60%, #fde68a 100%)",
      borderRadius: "1.5rem",
      boxShadow: "0 4px 24px rgba(251,191,36,0.12)",
      padding: "2.5rem 2rem",
      minWidth: 260,
      maxWidth: 320,
      textAlign: "center",
      color: "#7c4700",
      border: "2px solid #fbbf24",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between"
    }}
  >
    <div id="pricing">
      <h2 style={{ color: "#f59e42", fontSize: 24, marginBottom: 8 }}>Donación</h2>
      <div style={{ fontSize: 32, fontWeight: "bold", marginBottom: 12 }}>Invítame a un café</div>
      <ul style={{ listStyle: "none", padding: 0, marginBottom: 20, color: "#7c4700", textAlign: "left" }}>
        <li>☕ Apoya el desarrollo</li>
        <li>💛 Sin ventajas extra, solo agradecimiento</li>
        <li>✔️ Todo lo del plan Gratis</li>
      </ul>
    </div>
    <button
      className="landing-btn-final"
      style={{ width: "100%", marginTop: "auto" }}
      onClick={() => window.open("https://www.paypal.com/donate/?business=jabecerramorilla21@gmail.com&currency_code=EUR", "_blank")}
    >
      Donar
    </button>
  </div>
</div>

        {/* Final CTA */}
        <div className="landing-final-cta">
          <h3>¿Listo para ser más productivo?</h3>
          <p>
            Únete a miles de profesionales que ya han transformado su productividad con PomTask.
          </p>
          <button
            className="landing-btn-final"
            onClick={() => handleNavigation("/signup")}
          >
            <span className="btn-content">
              Empezar Ahora
              <ZapIcon />
            </span>
          </button>
        </div>
      </main>
    </div>
  );
};

export default LandingPage;